import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/developers/widget/CopyButton.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
